import { useState } from "react";
import { Alert, Button, Card, Form, Input, message } from "antd";
import { Link } from "react-router-dom";

import classes from "./ForgotPassword.module.scss";
import { forgotPasswordAPI } from "../../API/endpoints/auth";
import ReCaptcha from "./ReCaptcha";

export default function ForgotPasswordCard() {
  const [error, setError] = useState();
  const [loading, setLoading] = useState();
  const [captchaValue, setCaptchaValue] = useState(null);

  const [messageApi, contextHolder] = message.useMessage();

  const handleSubmit = async (email) => {
    try {
      if (!captchaValue) {
        return;
      }
      setError(false);
      setLoading(true);
      await forgotPasswordAPI(email, captchaValue);
      messageApi.open({
        type: "success",
        style: {
          marginTop: 100,
        },
        content: "The password reset link has been sent to your email",
      });
    } catch (error) {
      setError(error.response?.data?.message || "Something went wrong");
      setCaptchaValue(null);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Card title="Forgot password" className={classes.card}>
      {error && <Alert message={error} type="error" />}
      {contextHolder}
      <Form
        name="basic"
        onFinish={handleSubmit}
        autoComplete="off"
        layout="vertical"
        size="large"
      >
        <Form.Item
          name="email"
          label="Email"
          rules={[
            {
              required: "true",
              type: "email",
              message: "Email is not a valid email!",
            },
          ]}
        >
          <Input placeholder="Enter your email" />
        </Form.Item>

        <ReCaptcha value={captchaValue} onChange={setCaptchaValue} />

        <Form.Item className={classes.submitButton}>
          <Button type="primary" htmlType="submit" block disabled={loading}>
            {loading ? "Sending..." : "Send"}
          </Button>
        </Form.Item>
      </Form>
      <Link to={"/auth/login"} className={classes.clickableSpan}>
        Back to Login
      </Link>
    </Card>
  );
}
